// import React, { useState, useRef, useEffect } from "react";
// import "./style/filter.css";
// import { assets } from "../../../assets/assets";
// import SearchFilter from "./searchFilter";
// import Range from "./range";
// import VillaCard from "../../villacard/VillaCard";
// import Tabs from "./tabs";
// import Button from "../../button/button";
// import { useZone } from "../../../context/ZoneContext";
// import { useFilterContext } from "../../../context/FilterContext";
// import ar from "../../../lang/ar";
// import en from "../../../lang/en";
// function Filter({ lang }) {
//   const { units, loading } = useZone();
//   const { filteredUnits } = useFilterContext();
//   const [isOpen, setIsOpen] = useState(true);
//   const [showSideMenu, setShowSideMenu] = useState(false);
//   const filterRef = useRef(null);
//   const sideMenuRef = useRef(null);
//   const [progressVilla, setProgressVilla] = useState(null);
//   const ITEMS_PER_PAGE = 10;
//   const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
//   const [menuWidth, setMenuWidth] = useState(
//     window.innerWidth >= 1200 ? "560px" : "400px",
//   );
//   const [columns, setColumns] = useState(window.innerWidth >= 1200 ? 2 : 1);
//   const translations = lang === "ar" ? ar : en;
//   useEffect(() => {
//     const onResize = () => {
//       setMenuWidth(window.innerWidth >= 1200 ? "560px" : "400px");
//     };

//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);
//   useEffect(() => {
//     const onResize = () => {
//       setColumns(window.innerWidth >= 1200 ? 2 : 1);
//     };

//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   useEffect(() => {
//     const updateHeight = () => {
//       if (filterRef.current && sideMenuRef.current) {
//         sideMenuRef.current.style.height = `${filterRef.current.offsetHeight}px`;
//       }
//     };
//     updateHeight();
//     window.addEventListener("resize", updateHeight);
//     return () => window.removeEventListener("resize", updateHeight);
//   }, [showSideMenu]);

//   // if (loading) return <div>Loading...</div>;

//   const visibleUnits = filteredUnits.slice(0, visibleCount);

//   return (
//     <>
//       <div
//         ref={filterRef}
//         className={`filter-sidebar d-none d-lg-flex ${
//           lang === "ar" ? "right-side" : "left-side"
//         } ${isOpen ? "show-menu" : "hide-menu"}`}
//       >
//         {/* محتوى الفلتر هنا */}
//         <div className="accordion-item overflow-hidden m-0 p-0">
//           <div className="accordion-header">
//             <button
//               className="accordion-button"
//               type="button"
//               data-bs-toggle="collapse"
//               data-bs-target="#collapseFilter"
//               aria-expanded="true"
//               aria-controls="collapseFilter"
//               onClick={() => setIsOpen(!isOpen)}
//             >
//               {isOpen
//                 ? lang === "ar"
//                   ? "إخفاء القائمة"
//                   : "Hide Menu"
//                 : lang === "ar"
//                   ? "إظهار القائمة"
//                   : "Show Menu"}
//               <img src={assets.filter} alt="Hide Menu" />
//             </button>
//           </div>
//           <div
//             id="collapseFilter"
//             className="accordion-collapse collapse show"
//             data-bs-parent="#filterAccordion"
//           >
//             <div className="accordion-body">
//               {/* Search Filter */}
//               <SearchFilter
//                 lang={lang}
//                 onToggleMenu={(value) =>
//                   setShowSideMenu(
//                     typeof value === "boolean" ? value : !showSideMenu,
//                   )
//                 }
//               />

//               {/* Tabs */}
//               <Tabs lang={lang} />

//               {/* Range Slider */}
//               <Range units={units} lang={lang} />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Side Menu with results */}
//       {showSideMenu && (
//         <div
//           ref={sideMenuRef}
//           className={`side-menu- ${lang === "ar" ? "right" : "left"}`}
//           style={{
//             width: menuWidth,
//             maxWidth: "100vw",
//             transition: "width 0.25s ease",
//           }}
//         >
//           <div className="side-menu-header">
//             {filteredUnits.length === 0 ? (
//               <p className="m-0">{lang === "ar" ? "لا يوجد وحدات" : "No units found"}</p>
//             ) : (
//               <p className="m-0">
//                 {translations.showed} ({visibleUnits.length}) {translations.of}{" "}
//                 ({filteredUnits.length})
//               </p>
//             )}
//           </div>
//           <div
//             className="card card-body p-0 border-0 col-12 bg-transparent"
//             style={{
//               display: "grid",
//               gridTemplateColumns: `repeat(${columns}, 1fr)`,
//               gap: "1rem",
//               padding: 0,
//               margin: 0,
//             }}
//           >
//             {visibleUnits.map((unit) => (
//               <div key={unit.id} style={{ width: "100%" }}>
//                 <VillaCard
//                   villa={unit}
//                   lang={lang}
//                   page="master-plan"
//                   hideHeader={true}
//                   onShowProgress={(villa) => setProgressVilla(villa)}
//                 />
//               </div>
//             ))}

//           </div>
//            {/* Show More button */}
//             {visibleCount < filteredUnits.length &&
//               filteredUnits.length > ITEMS_PER_PAGE && (
//                 <div className="col-12 text-center mt-3">
//                   <Button
//                     text={translations.showMore}
//                     className="main-btn"
//                     onClick={() =>
//                       setVisibleCount((prev) =>
//                         Math.min(prev + ITEMS_PER_PAGE, filteredUnits.length),
//                       )
//                     }
//                   />
//                 </div>
//               )}
//         </div>
//         // </div>
//       )}
//     </>
//   );
// }
// export default Filter;
// 14/3

import React, { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./style/filter.css";
import { assets } from "../../../assets/assets";
import SearchFilter from "./searchFilter";
import Range from "./range";
import VillaCard from "../../villacard/VillaCard";
import Tabs from "./tabs";
import Button from "../../button/button";
import { useZone } from "../../../context/ZoneContext";
import { useFilterContext } from "../../../context/FilterContext";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function Filter({ lang }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { units, loading } = useZone();
  const { filteredUnits } = useFilterContext();
  const [isOpen, setIsOpen] = useState(true);
  const [showSideMenu, setShowSideMenu] = useState(false);
  const filterRef = useRef(null);
  const sideMenuRef = useRef(null);
  const [progressVilla, setProgressVilla] = useState(null);
  const ITEMS_PER_PAGE = 10;
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const [menuWidth, setMenuWidth] = useState(
    window.innerWidth >= 1200 ? "560px" : "400px",
  );
  const [columns, setColumns] = useState(window.innerWidth >= 1200 ? 2 : 1);
  const translations = lang === "ar" ? ar : en;
  useEffect(() => {
    const onResize = () => {
      setMenuWidth(window.innerWidth >= 1200 ? "560px" : "400px");
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect(() => {
    const onResize = () => {
      setColumns(window.innerWidth >= 1200 ? 2 : 1);
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      if (filterRef.current && sideMenuRef.current) {
        sideMenuRef.current.style.height = `${filterRef.current.offsetHeight}px`;
      }
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [showSideMenu]);

  // if (loading) return <div>Loading...</div>;

  const visibleUnits = filteredUnits.slice(0, visibleCount);

  return (
    <>
      <div
        ref={filterRef}
        className={`filter-sidebar d-none d-lg-flex ${
          lang === "ar" ? "right-side" : "left-side"
        } ${isOpen ? "show-menu" : "hide-menu"}`}
      >
        {/* محتوى الفلتر هنا */}
        <div className="accordion-item overflow-hidden m-0 p-0">
          <div className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFilter"
              aria-expanded="true"
              aria-controls="collapseFilter"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen
                ? lang === "ar"
                  ? "إخفاء القائمة"
                  : "Hide Menu"
                : lang === "ar"
                  ? "إظهار القائمة"
                  : "Show Menu"}
              <img src={assets.filter} alt="Hide Menu" />
            </button>
          </div>
          <div
            id="collapseFilter"
            className="accordion-collapse collapse show"
            data-bs-parent="#filterAccordion"
          >
            <div className="accordion-body">
              {/* Search Filter */}
              <SearchFilter
                lang={lang}
                onToggleMenu={(value) =>
                  setShowSideMenu(
                    typeof value === "boolean" ? value : !showSideMenu,
                  )
                }
              />

              {/* Tabs */}
              <Tabs lang={lang} />

              {/* Range Slider */}
              <Range units={units} lang={lang} />
            </div>
          </div>
        </div>
      </div>

      {/* Side Menu with results */}
      {showSideMenu && (
        <div
          ref={sideMenuRef}
          className={`side-menu- ${lang === "ar" ? "right" : "left"}`}
          style={{
            width: menuWidth,
            maxWidth: "100vw",
            transition: "width 0.25s ease",
          }}
        >
          <div className="side-menu-header">
            {filteredUnits.length === 0 ? (
              <p className="m-0">
                {lang === "ar" ? "لا يوجد وحدات" : "No units found"}
              </p>
            ) : (
              <p className="m-0">
                {translations.showed} ({visibleUnits.length}) {translations.of}{" "}
                ({filteredUnits.length})
              </p>
            )}
          </div>
          <div
            className="card card-body p-0 border-0 col-12 bg-transparent"
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${columns}, 1fr)`,
              gap: "1rem",
              padding: 0,
              margin: 0,
            }}
          >
            {visibleUnits.map((unit) => (
              <div key={unit.id} style={{ width: "100%" }}>
                <VillaCard
                  villa={unit}
                  lang={lang}
                  page="master-plan"
                  hideHeader={true}
                  onShowProgress={(villa) => setProgressVilla(villa)}
                  onUnitClick={(code) => {
                    setSearchParams({ unit: code }, { replace: true });
                    setShowSideMenu(false);
                  }}
                />
              </div>
            ))}
          </div>
          {/* Show More button */}
          {visibleCount < filteredUnits.length &&
            filteredUnits.length > ITEMS_PER_PAGE && (
              <div className="col-12 text-center mt-3">
                <Button
                  text={translations.showMore}
                  className="main-btn"
                  onClick={() =>
                    setVisibleCount((prev) =>
                      Math.min(prev + ITEMS_PER_PAGE, filteredUnits.length),
                    )
                  }
                />
              </div>
            )}
        </div>
        // </div>
      )}
    </>
  );
}
export default Filter;
